import { render, staticRenderFns } from "./UniversityExamListing.vue?vue&type=template&id=dad5ad0a"
import script from "./UniversityExamListing.vue?vue&type=script&lang=js"
export * from "./UniversityExamListing.vue?vue&type=script&lang=js"
import style0 from "./UniversityExamListing.vue?vue&type=style&index=0&id=dad5ad0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports